import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AguaPotableComponent } from "./agua-potable/agua-potable.component";
import { DrenajeComponent } from "./drenaje/drenaje.component";

const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "agua-potable",
        component: AguaPotableComponent
      }
    ]
  },
  {
    path: "",
    children: [
      {
        path: "drenaje",
        component: DrenajeComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OperacionRoutingModule {}
